require('./index.css');
let request = require('@common/request');
let iBorad = require('@common/iBorad');
let mask = require('../mask/index');
try {
  var tguid = qbsdk.getServerGuid();//window.external.getFavSyncGuid();
} catch (e) {

}
var strHref = location.href;
var intPos = strHref.indexOf("?");
var strRight = strHref.substr(intPos + 1);
var arrTmp = strRight.split("&");
var isMecenter = false;

console.log(arrTmp.length);
for(var i = 0; i < arrTmp.length; i++) {
  var arrTemp = arrTmp[i].split("=");
  if(arrTemp[0].toUpperCase() == "ADTAG"){
    console.log(arrTemp[1]);//mecenter
    if(arrTemp[1] == 'mecenter'){
      isMecenter = true;
    }
  }
}

function Lottery() {
  var _$ = $;
  var _that = this;
  this.inGame = false;
  this.showNotShare = false;
  this._pageUrl = location.protocol + '//' + location.host + location.pathname;

  this.isFollowed = false;
  this.isShared = false;
  this.isVoted = false;

  //查询是否投票过 304087
  this.getVoted = function () {
    request.send({
      'actid': 304084,
    }, function (res) {
      if (res.ret === 0) {
        if (res.data.op.count >= 1) { //分享过
          _that.isVoted = true;

          console.log('已经投票过--')
        } else { //没分享过
          _that.isVoted = false;
          console.log('没有投票过--')
        }
      }
    });
  };
  //首次登录加机会
  this.firstLogin = function () {
    request.send({
      'actid': 304087,
    }, function (res) {
      if (res.ret === 0) {

          console.log('没有登录过--')

      }else if(res.ret ==10603){
        console.log('已经登录过--')
      }else{
        console.log('exception code -->'+res.ret);
      }
      window.lottery.setMoney();
    });
  }

  // 抽奖
  this.getLucky = function () {
    if (!qq.login.getUin()) {
      qq.login.open();return;
    }
    var _that = this;
    if (_that.inGame) {//正在抽奖
      console.log('is --- going---!!!!!!!!!!!!!!');
      return;
    }
    if (new Number($("#money").text()) == 0) { //0 次点击时判断 是否分享过
      if (this.isVoted) {
        mask('nochance', '抽奖机会已用完，', '为选手投票可额外获得1次抽奖机会哦！');
        return;
      }else{
        mask('activtyEnd', '抽奖机会已用完，', '参加测试可额外获得1次抽奖机会哦！');
        return;
      }
    }

    _qblog.wsd.click("LOVEAPARTMENT.LUCKY");
    _that.inGame = true;//开始发请求 然后开始抽奖
    request.send({
            // 抽奖id
            'actid': 300499,
          }, function (res) {
            // var res = {
            //   data: {
            //     join: {
            //       level: 4
            //     },
            //     op: {
            //       cdkey: '111111111111111111',
            //       diamonds: 3,
            //       name: '一年假期',
            //       count: 0
            //     }
            //   },
            //   ret: 0
            // }
            if (res.ret === 0) { //展示奖品
              _that.setMoney();
            //  _qblog.wsd.click("LOVEAPARTMENT.LUCKY.OK")
              var key = res.data.op.diamonds;
              var cdkey = res.data.op.cdkey;
              if (key <= 3) {
                  openPrizeMask(key,cdkey);//7 是谢谢惠顾
                  _that.inGame = false;
              } else {
                // 如果是谢谢惠顾什么也不谈
                if(key==4){
                    _that.inGame = false;
                  if(window.lottery.isVoted){
                    mask('littleFollow', '', '好遗憾，还差一点点就中奖啦~');
                  }else{
                    mask('thanks', '', '');
                  }
                }else{
                  console.warn("wrong-prize-leverl---!!!");
                }
              }

            } else if (res.ret === 20801) { //没有机会啦
              // 查询今天是否分享过
              request.send({
                'actid': 296669,
              }, function (res) {
                if (res.ret === 0) { //分享过
                  if (res.data.op.count >= 1) {
                    mask('activtyEnd', '今日抽奖机会已到上限啦，明天再分享依然', '可获得额外机会！')
                  } else {
                    mask('shareGetChance');
                  }
                }
                _that.inGame = false;
              });
            } else if (res.ret === 10002) {
              qq.login.open();
              _that.inGame = false;
            } else if (res.ret == 10001 || res.ret == 10004) {
              mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '')
              _that.inGame = false;
            }
          });
        };


  this.vote = function () {
    var _that = this;
    _qblog.wsd.click("LOVEAPARTMENT.VOTE");
    request.send({
      'actid': 300528, //投票增加机会
    }, function (res) {
      if (res.ret === 0) {
        //分享成功
        _that.setMoney();
      //  _qblog.wsd.click("EMPRESS.SUCCESS")
      }else{
        console.log(res);
      }
      window.setTimeout(function () {
        _that.isVoted = true;//给弹窗一个时间 显示第一次 答题后的提示
      },600)
      _that.isVoted = true;
    });
  };
  this.testXu = function (index) {
      if (index < 7) {
          openPrizeMask(index,"xxxxx");//7 是谢谢惠顾
      } else if(index ==7 ){
        if(window.lottery.isVoted){
          mask('littleFollow', '', '好遗憾，还差一点点就中奖啦~');
        }else{
          mask('thanks', '', '');
        }

      }
      else if(index ==9){// 如果是谢谢惠顾什么也不谈
        mask('shareGetChance');
       // mask('errorCode','','订阅请求失败，错误码：xxxxx');
      }
      else if(index>9){
        mask('answerNum', '测试结果：100分','');
       // mask('nochance', '抽奖机会已用完，', '为选手投票可额外获得1次抽奖机会哦！');
       //  $("html,body").animate({
       //    scrollTop: 830
       //  }, 200);
      }

    //openPrizeMask(index,"xxxxx");
  };
  function openPrizeMask(key, code) {
    var prizeArr = [0, '爱情公寓免费电影票兑换码', '猫眼电影票代金券', '个人中心 2 积分', '腾讯视频VIP季卡', 'Q币X10个', 'Q币X5个'];
    var title = prizeArr[key];
    var str = '';
    str += '<div class="tit">恭喜获得 ' + title + '</div>';
    //四等奖月卡添加cdkey
    str += '<div class="mask-show-prize-img' + key + ' mask-show-prize-img"></div>';
    // console.log(key,"=======",res.data,"----------",title)
    switch (key) {
      case 1:
        str += '<div class="show-prize-code">兑换码:' + code + '</div>';
        str += '<div class="show-prize-get-context-img-2 close"><a href="#" class="">我知道了</a>';break;
      case 2:
        str += '<div class="show-prize-qrcode">' +'<img src="http://stdl.qq.com/stdl/qb/kp/la_qrcode.png">'+
          '</div>';
        str += '<div class="show-prize-get-context-img-2 close"><a href="#" class="">我知道了</a>';
        break;
      case 3: str += '<div class="show-prize-code-null">前往个人中心兑换礼品吧</div>';
        str += '<div class="show-prize-get-context-img close margin-b16"><a href="http://i.browser.qq.com/" target="_blank" class="">去兑换</a>';
        break;
      case 4:
        str += '<div class="show-prize-code-null"></div>';
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a>';
        break;

      case 5:
      case 6:
        str += '<div class="show-prize-code-null"></div>';
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a>';
        break;
      default:
        str += '<div class="show-prize-get-context-img close"><a href="#" class="">我知道了</a> ';
    }

    switch (key){
      case 1:str += '</div><div class="rule"><p>使用说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 兑换码有效兑换时间：2018年9月9日23:59:59前；</p>';
        str += '<p>● 兑换电影票请前往淘票票平台进行兑换，仅限兑换单片《爱情公寓》售价2D不高于55元的场次；</p>';
        str += '<p>● 想再来1张，你还可以前往个人中心凭已有积分换取更多哦</p>';
        str += '</div>';break;
      case 2:str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
        str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
        str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
        str += '</div>';break;
      case 3:str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
        str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
        str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
        str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
        str += '</div>';break;
    }
    // str += '</div><div class="rule"><p>奖品说明：</p><div class="rule-juli"></div>';
    // str += '<p class="import">● 同一用户仅限领取一张电影抵用券；</p>';
    // str += '<p>● 电影抵用券仅限在线选座购买《爱情公寓》使用，该券不可与平台其他优惠同享，领取后7日内有效；</p>';
    // str += '<p>● 领取的电影抵用券可在美团客户端【我的】-【红包/卡券】中查看，或猫眼客户端【我的】-【优惠券】中查看</p>';
    // str += '</div>';

    mask('showPrize', '', '');
    setTimeout(function () {
      $('.dialog-show-prize .gifts').html(str);
    }, 100);
  }

  //查询中奖记录
  var isquery = false;
  this.queryRecord = function () {
    if (this.inGame) return;
    if (isquery) {
      return; //防止重复点击
    }
    isquery = true;
    _qblog.wsd.click("LOVEAPARTMENT.QUERYRECORD.CLICK");
    setTimeout(function () {
      isquery = false;
    }, 300);
    request.send({
      // zeroj 查询获奖记录
      'actid': 300530
    }, function (res) {
      if (res.ret == 0) {
        var msg = res.data.op;
        // var msg = [{
        //   val: {
        //     level: 2,
        //     time: 1521966470,
        //     name: "电影代金券",
        //     info: "11111111111111"
        //   }
        // }]
        var str = ''
        if (msg.length !== 0) {
          str = '<li><span>中奖日期</span><span>奖品名称</span><span>奖品详情</span><span>操作</span></li>';
          for (var i = 0; i < msg.length; i++) {
            if (msg[i].val.level == 2 ) { //二维码
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>二维码 <i class="qtips1"> ？<span class="qrcode">';
              str += '<div class="erwei">' +'<img src="http://stdl.qq.com/stdl/qb/kp/la_qrcode.png" />'+
                '</div> ';
              str += '</span></i></span>';
              str += '<span>请扫描</span></li>';
            } else if (msg[i].val.level == 1) { // 去兑换电影票
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>兑换码：' + msg[i].val.info;
              str += ' <i class="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● 兑换码有效兑换时间：2018年9月9日23:59:59前；</p></li>\
                                              <li><p>● 兑换电影票请前往淘票票平台进行兑换，仅限兑换单片《爱情公寓》售价2D不高于55元的场次；</p></li>\
                                              <li><p>● 想再来1张，你还可以前往个人中心凭已有积分换取更多哦</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span><a href="https://dianying.taobao.com/" class="userCon" target="_blank">去兑换</a></span></li>';
            } else if (msg[i].val.level == 3) { // 虚拟奖品 2积分
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>虚拟奖品 <i class="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span>自动到账</span></li>';
            }
          }
        } else {
          str += '<div id="space">'
          str += '<img src="http://stdl.qq.com/stdl/qb/kp/space.png">'
          str += '<p>暂无获奖记录，快去参加活动吧</p>'
          str += '</div>'
        }

        mask('myGifts');
        $('.dialog-myGifts .giftRecord .gifts').html(str);
      } else if (res.ret == 10002) {
        qq.login.open();
      } else if (res.ret == 10001 || res.ret == 10004) {
        mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '')
      } else {
        zHttp.showResponse(res, res.actid, $.noop);
      }
    });
  };
  //设置抽奖次数 从后台接口返回
  this.setMoney = function () {
    //@@
    request.send({
      'actid': 304092,
    }, function (res) {
      if (res.ret == 0) {
        var m = res.data.op;
        _that.luckNum = m;
        console.log('luckNum --->' + m);
        $('#money').text(m);
      }
    });
  };
  this.setUserContact = function () {
    userAddress.submitUserInfo("userName", "phoneNum",
      "detailAddr",
      "zipCode",
      function () {
        _$(".dialog-user-contact #success-submit").fadeIn(500).fadeOut(500)
      });
  }
  this.getUserContact = function () {
    userAddress.getUserInfo(function (res) {
      $('#userCon .userInfo').html(userAddress.tempContact(res));
    });
    mask('userCon');
  };
}
window.lottery = new Lottery()



// WEBPACK FOOTER //
// ./modules/lottery/index.js